import Vue from 'vue';
import Vuex from 'vuex';
import authModule from './modules/auth';
import instrumentsModule from './modules/instruments';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: authModule,
    instruments: instrumentsModule,
  },
});